import React from 'react'
import { Link } from 'react-router-dom'

const testIdByPath = {
    '/': 'dashboard-link',
    '/profile': 'profile-link',
    '/calendar': 'calender-link',
    '/reservation-history': 'reservation-history-link',
    '/payment-details': 'payment-link',
    '/account-setup': 'account-setup-link',
    '/finances': 'payout-link',
    '/plan-setup': 'plan-setting-link',
    '/club-setup': 'club-profile-link',
    '/players': 'member-link',
    '/email-notify': 'email-notify-link',
    '/calender-setup': 'calender-setting-link',
    '/ads-sponsorship': 'ads-sponsorship-link',
};

const SideBarLink = ({ to, closeWithClick, activeTab,name,LinkIcon }) => {

    return (
        <Link
            data-testid={testIdByPath[to] || 'sidebar-link'}
            to={to}
            onClick={closeWithClick}
            className={activeTab? "active" : ""}
            title={name}
        >
          { LinkIcon && <LinkIcon className="slide-bar-icons" />}
          <span className="slide-bar-label">{name}</span>
        </Link>
    )
}

export default SideBarLink